/**
 * Adapter for the standard conditionally-mounted dialog contract:
 * the dialog renders only while open, so onOpenChange only ever needs to funnel
 * the closing transition (Esc, overlay click, close button) into `onClose`.
 *
 * Naming convention for dialogs going forward: `onClose` closes without side
 * effects; `onMutated` fires after a successful mutation so the caller can
 * refetch. Rename legacy synonyms (onSubmitted/onCreated/onCompleted/onUpdated)
 * only when their files are touched anyway.
 */
export const closeOnly =
  (onClose: () => void) =>
  (open: boolean): void => {
    if (!open) onClose();
  };
